<template>
  <component
    :is="getContainerType"
    v-if="shouldRenderConfig"
    :class="getClassName"
  >
    <div
      v-for="(pageOption, key, index) in getProductPageOptions"
      v-show="IsActive(key)"
      :key="index"
      :code="key"
      :index="index"
      :class="getClassNameItem"
    >
      <component :is="getTransitionUsedElement" name="fade">
        <appPageOptionAttributesContainer
          v-show="IsActive(key)"
          :code="key"
          :ppcode="ppcode"
        ></appPageOptionAttributesContainer>
      </component>
    </div>
  </component>
</template>
<script>
import { mapState, mapActions } from "pinia";

import { useWebproductStore } from "@/stores/modules/webproduct";
export default {
  computed: {
    ...mapState(useWebproductStore, [
      "getActiveProductPageOptions",
      "getActivePageOptionsForPP",
      "getProductPageOptionsForCode",
      "getTransitionUsedElement"
    ]),
    getProductPageOptions: function () {
      if (this.ppcode) {
        return this.getProductPageOptionsForCode({ code: this.ppcode });
      }
      return this.getActiveProductPageOptions;
    }
  },

  methods: {
    IsActive: function (pageOption) {
      return pageOption == this.getActivePageOptionsForPP(this.ppcode);
    }
  },
  props: ["hideContainer", "ppcode"]
};
</script>
